/* eslint-disable import/no-anonymous-default-export */
import { get } from "lodash";

import Amplify, { Auth } from "aws-amplify";

import awsconfig from "pages/auth/aws-exports";
import { apiUrl } from "./dataProvider";

Amplify.configure(awsconfig);

export default {
  login: ({ email, password }: any) => {
    const type = "superadmin";
    const request = new Request(`${apiUrl}/auth/login`, {
      method: "POST",
      body: JSON.stringify({ email, password, type }),
      headers: new Headers({ "Content-Type": "application/json" }),
    });

    return fetch(request)
      .then((response) => {
        if (response.status < 200 || response.status >= 300) {
          throw new Error(response.statusText);
        }
        return response.json();
      })
      .then(({ token }) => {
        // store  jwt to localstorage
        // then read it's payload
        const payload = parseJwt(token);

        // check if parent, will reject the login
        const rolesPayload: string[] =
          payload[
            "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
          ];

        if (
          rolesPayload.includes("parent") ||
          rolesPayload.includes("company") ||
          rolesPayload.includes("personInCharge")
        ) {
          clearLocalStorage();
          return Promise.reject();
        }

        localStorage.setItem("token", token);
        localStorage.setItem("roles", rolesPayload.toString());
        localStorage.setItem("userId", payload["userId"]);

        return payload;
      })
      .then(({ user }) => {
        // set the properties of the app,
        // based on the payload.
        localStorage.setItem("me", user);
        // localStorage.setItem("roles", JSON.stringify(roles));
        // based on the roles, store the permissions of the user
        // localStorage.setItem(
        //   "permissions",
        //   JSON.stringify(getPermissions(roles))
        // );
        return Promise.resolve();
      });
  },
  logout: () => {
    Auth.signOut().then(() => clearLocalStorage());
    return Promise.resolve();
  },
  checkAuth: () => {
    return localStorage.getItem("token") ? Promise.resolve() : Promise.reject();
  },
  checkError: (error: any) => {
    const status = error.status;
    if (status === 401 || status === 403) {
      localStorage.removeItem("token");

      return Promise.reject({ redirectTo: "/login?err=1" });
    }
    return Promise.resolve();
  },

  getPermissions: (params: any) => {
    const permissions = localStorage.getItem("permissions");
    if (!permissions) {
      return Promise.reject();
    }

    return Promise.resolve((search: string) =>
      can(search, JSON.parse(permissions))
    );
  },
};

const getPermissions = (roles: string[]) => {
  const permissionList = {
    super_admin: ["*"],
    customer_admin: [
      "orders.read",
      "settings.read",
      "dashboard.read",
      "dashboard.read.customer_acquisition",
      "dashboard.read.orders",
    ],
  };

  const reducer = (accumulator: string[], key: string) => {
    const permissions = get(permissionList, key, []);
    return accumulator.concat(permissions);
  };

  return roles.reduce(reducer, []);
};

const can = (search: string, permissions: string[]) => {
  if (permissions.includes("*")) {
    return true;
  }

  return permissions.includes(search);
};

const clearLocalStorage = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("me");
  localStorage.removeItem("roles");
  localStorage.removeItem("permissions");
  localStorage.removeItem("loginType");
  localStorage.removeItem("tenantId");
  localStorage.removeItem("userId");
  sessionStorage.setItem("school", null);
};

/**
 * A function to parse JWT to get the paylod
 *
 * @param token JWT string
 */
const parseJwt = (token: string) => {
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  return JSON.parse(jsonPayload);
};
